import { cn } from '@shadcn/lib/utils';
import { ArrowLeft } from 'lucide-react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export function BackLink({ className, text, onBack }: IBackLinkProps) {
  const { t } = useTranslation();
  const backText = text ?? t('navigation.back');

  const handleBack = useCallback(() => {
    if (onBack) {
      onBack();
    } else if (typeof window !== 'undefined' && window.history) {
      window.history.back();
    }
  }, [onBack]);

  return (
    <button
      className={cn('flex items-center gap-1 py-3 text-left hover:bg-gray-50 cursor-pointer', className)}
      onClick={handleBack}
      type="button"
    >
      <ArrowLeft size={12} />
      <div className="text-slate-800 text-sm font-semibold">{backText}</div>
    </button>
  );
}

export interface IBackLinkProps {
  readonly text?: string;
  readonly className?: string;
  readonly onBack?: () => void;
}
